/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export * from "./types/base";
export * from "./types/polyfills";
export * from "./types/cls";
export * from "./types/fcp";
export * from "./types/fid";
export * from "./types/inp";
export * from "./types/lcp";
export * from "./types/ttfb";
export var GLOBAL_OBJ = window;
export var WINDOW = GLOBAL_OBJ;

// --------------------------------------------------------------------------
// Web Vitals package globals
// --------------------------------------------------------------------------

// --------------------------------------------------------------------------
// Everything below is modifications to built-in modules.
// --------------------------------------------------------------------------

// Update built-in types to be more accurate.